import React, { useEffect } from 'react'

import AutoStoriesOutlinedIcon from '@mui/icons-material/AutoStoriesOutlined'
// import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined'
import { Button } from '@mui/material'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useSelector } from 'react-redux'

import type { RootState } from 'reduxStore'

import * as Model from 'api/model'
import AboutPanelSiteDetails from 'drawer/tabs/about/AboutPanelSiteDetails'
import PoziLogo from 'img/powered-by-pozi.png'

const styles = {
  root: {
    height: '100%'
  },
  details: {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    padding: '10px'
  },
  button: {
    justifyContent: 'center',
    width: '260px'
  },
  logo: {
    height: '55px',
    marginBottom: '25px'
  }
}

const AboutPanel: React.FC = () => {
  const isAboutTabLoaded = useSelector((state: RootState) =>
    state.config?.layout?.drawer?.tabs?.loaded?.about ?? false
  )

  useEffect(() => {
    const aboutTabButton = document.getElementById('pozi-drawer-tabs-button-about')
    if (aboutTabButton) {
      const handleClick = () => {
        Model.set('app.drawer.activetabid', 'about')
      }
      aboutTabButton.addEventListener('click', handleClick, false)

      return () => {
        aboutTabButton.removeEventListener('click', handleClick, false)
      }
    }
  }, [])

  // Optimisation to avoid loading panels if not on about tab.
  // Note this is set indirectly by Model.set('app.drawer.activetabid', 'about')
  if (!isAboutTabLoaded) {
    return null
  }

  const Logo = (
    <a href="https://pozi.com" target="_blank" rel="noopener noreferrer" style={{ cursor: 'pointer' }}>
      <img src={PoziLogo} alt="Powered by Pozi" style={styles.logo} />
    </a>
  )

  return (
    <Stack direction="column" justifyContent="space-between" spacing={2} sx={styles.root}>
      <Stack direction="column" spacing={1} sx={styles.details}>
        <Typography variant="h6">Site Information</Typography>
        <AboutPanelSiteDetails />
      </Stack>
      <Stack direction="row" justifyContent="center" spacing={1}>
          {/* <Button sx={styles.button}><VideocamOutlinedIcon />Quick Start</Button> */}
          <Button sx={styles.button} onClick={() => window.open('https://docs.pozi.com/user-guide/', '_blank')}>
            <AutoStoriesOutlinedIcon /> User Guide
          </Button>
      </Stack>
      <Stack direction="row" justifyContent="center">
        {Logo}
      </Stack>
    </Stack>
  )
}

export default AboutPanel
